import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../assets/svg/svg27.svg";
import svg12 from "../../../../assets/svg/svg12.svg";
import svg13 from "../../../../assets/svg/svg13.svg";
import svg9 from "../../../../assets/svg/svg9.svg";
import CardLoading from "../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchData,
  generateReport,
} from "../../../../features/fetch/fetchSlice";
import moment from "moment";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import ConfirmModal from "../../../../components/ConfirmModal";
import { setActiveObj } from "../../../../features/obj/objSlice";

function ReportsByDateTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "project/fetch_projects";
  const { loading, data, count, activeObjMontProj, loadingGenerateReport } =
    useSelector((state) => ({
      loading: state.fetch.loading,
      loadingGenerateReport: state.fetch.loadingGenerateReport,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjMontProj: state.obj.activeObj["montProj"],
    }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "montProj", data: prodd }));
    await navigate("/rob/progress-add");
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "project/delete_project",
        projId: prodd?.projId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchTableData();
      await handleCloseDelete();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleDownload = async () => {
    const res = await dispatch(
      generateReport({
        url: "api/v1/reports/directReport",
        reportName: "MnE_REPORT",
        itemId: prodd?.projId,
        reportFormat: "PDF",
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];

      let fileName = "report";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" />{" "}
            <span className="whitespace-nowrap">Edit</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={handleDownload}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg9} alt="svg9" />{" "}
            <span className="whitespace-nowrap">Download</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },

    {
      key: "3",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg13} alt="svg13" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 10,
      render: (_, __, index) => index + 1,
    },

    {
      title: "Created Date",
      dataIndex: "projCreatedDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
    },

    {
      title: "Inspection Date",
      dataIndex: "projEvalDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
    },

    {
      title: "Actions",
      align: "right",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        projProjectId: activeObjMontProj?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  // useEffect(() => {
  //   fetchTableData();
  // }, []);

  if ((loading && !searchInput) || loadingGenerateReport)
    return <CardLoading />;
  return (
    <div className="flex flex-col w-full  flex-1   mt-[2.5rem]">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="form-add-h">Reports by Date</div>
      </div>

      <div className="max-w-full w-full overflow-x-auto">
        <Table
          rowSelection={false}
          className="mt-[1.75rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.projectId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default ReportsByDateTable;
